import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../views/HomePage.vue'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            redirect: '/index/HomePage',
        },

        //视频播放页--舞美个人
        {
            path: '/index/CourseVideoMain',
            name: 'CourseVideoMain',
            component: () => import('../views/courseView/CourseVideoMain.vue')
        },
        {
            path: '/index/CourseCountinueVideoMain',
            name: 'CourseCountinueVideoMain',
            component: () => import('../views/courseView/CourseCountinueVideoMain.vue')
        },

        // 视频播放页--网络培训
        {
            path: '/index/NetCourseVideoMain',
            name: 'NetCourseVideoMain',
            component: () => import('../views/networkPerform/CourseVideoMain.vue'),
        },

        //继续教育课程视频播放页

        // {
        //     path: '/index/WM_CourseVideo',
        //     name: 'WM_CourseVideo',
        //     component: () => import('../views/wumeigeren/WM_CourseVideoMain.vue'),
        // },

        // {
        //     path: '/index/NetCourseVideo',
        //     name: 'NetCourseVideo',
        //     component: () => import('../views/networkPerform/CourseVideo.vue'),
        // },

        // 网络表演视频播放
        // {
        //     path: '/index/NetCourseVideo',
        //     name: 'NetCourseVideo',
        //     component: () => import('../views/networkPerform/CourseVideoMain.vue'),
        // },

        //登录页
        {
            path: '/index/Login',
            name: 'Login',
            component: () => import('../views/userView/Login.vue'),
        },

        //企业注册
        {
            path: '/index/RegisterEnt',
            name: 'RegisterEnt',
            component: () => import('../views/userView/RegisterEnt.vue'),
        },

        //个人注册
        {
            path: '/index/RegisterUser',
            name: 'RegisterUser',
            component: () => import('../views/userView/RegisterUser.vue'),
        },

        {
            path: '/index',
            name: 'index',
            component: () => import('../views/Index.vue'),
            children: [

                //项目页面
                {

                    path: '/index/Project',
                    name: 'Project',
                    component: () => import('../components/Project.vue'),
                },
                //搜索页
                {

                    path: '/index/Search',
                    name: 'Search',
                    component: () => import('../components/Search.vue'),
                },
                //舞美首页
                {
                    path: '/index/WM_HomePage',
                    name: 'WM_HomePage',
                    component: () => import('../views/wumeigeren/WM_HomePage.vue'),
                },
                //详情
                {
                    path: '/index/wumei/NewsDetail',
                    name: 'NewsDetail',
                    component: () => import('../views/wumeiNews/NewsDetail.vue'),
                },
                // 考培通知
                {
                    path: '/index/WMNotice',
                    name: 'WMNotice',
                    component: () => import('../views/wumeiNews/WMNoticeList.vue'),
                },
                // 工作动态
                {
                    path: '/index/WMDynamicList',
                    name: 'WMDynamicList',
                    component: () => import('../views/wumeiNews/WMDynamicList.vue'),
                },

                // 业务指南
                {
                    path: '/index/BusinessGuideList',
                    name: 'BusinessGuideList',
                    component: () => import('../views/wumeiNews/BusinessGuideList.vue'),
                },

                //评价标准
                {
                    path: '/index/EvalStandardList',
                    name: 'EvalStandardList',
                    component: () => import('../views/wumeiNews/EvalStandardList.vue'),
                },

                //办事机构
                {
                    path: '/index/OrganList',
                    name: 'OrganList',
                    component: () => import('../views/wumeiNews/OrganList.vue'),
                },
                {
                    path: '/index/OrganDetail',
                    name: 'OrganDetail',
                    component: () => import('../views/wumeiNews/OrganDetail.vue'),
                },
                //信息公示
                {
                    path: '/index/InfoList',
                    name: 'InfoList',
                    component: () => import('../views/wumeiNews/InfoList.vue'),
                },
                {
                    path: '/index/WM_UserPage',
                    name: 'WM_UserPage',
                    component: () => import('../views/wumeigeren/WM_UserPage.vue'),
                },
                // 委员会
                {
                    path: '/index/ExpertList',
                    name: 'ExpertList',
                    component: () => import('../views/wumeiNews/ExpertList.vue'),
                },
                //报名页
                {
                    path: '/index/WM_EnrollPage',
                    name: 'WM_EnrollPage',
                    component: () => import('../views/wumeigeren/WM_EnrollPage.vue'),
                },
                //培训页
                {
                    path: '/index/WM_TrainPage',
                    name: 'WM_TrainPage',
                    component: () => import('../views/wumeigeren/WM_OfflineTrainPage.vue'),
                },
                //线下班次详情
                {
                    path: '/index/OfflineExamDet',
                    name: 'OfflineExamDet',
                    component: () => import('../views/wumeigeren/WM_OfflineTrainDet.vue'),
                },
                //复审 修改资料
                {
                    path: '/index/WM_ModifyReview',
                    name: 'WM_ModifyReview',
                    component: () => import('../views/wumeigeren/WM_ModifyReview.vue'),
                },
                //线上考试
                {
                    path: '/index/WM_OnlineExam',
                    name: 'WM_OnlineExam',
                    component: () => import('../views/wumeigeren/WM_OnlineExam.vue'),
                },
                //线上培训
                {
                    path: '/index/WM_OnlineCourse',
                    name: 'WM_OnlineCourse',
                    component: () => import('../views/wumeigeren/WM_OnlineCourse.vue'),
                },
                //支付页面-公共-个人
                {
                    path: '/index/OrderInfo',
                    name: 'OrderInfo',
                    component: () => import('../views/orderView/OrderInfo.vue'),
                },
                //支付页面-公共-企业
                {
                    path: '/index/OrderInfoCompany',
                    name: 'OrderInfoCompany',
                    component: () => import('../views/orderView/OrderInfoCompany.vue'),
                },
                  //确认邮寄信息
                {
                    path: '/index/WM_MailPage',
                    name: 'WM_MailPage',
                    component: () => import('../views/wumeigeren/WM_MailPage.vue'),
                },
                //查看线下邮寄信息
                {
                    path: '/index/WM_OfflineMaterials',
                    name: 'WM_OfflineMaterials',
                    component: () => import('../views/wumeigeren/WM_OfflineMaterials.vue'),
                },
                //培训页--换证
                // {
                //     path: '/index/WM_TrainPageChange',
                //     name: 'WM_TrainPageChange',
                //     component: () => import('../views/wumeigeren/WM_ChangeTrainPage.vue'),
                // },
                {
                    path: '/index/WM_CostSupp',
                    name: 'WM_CostSupp',
                    component: () => import('../views/wumeigeren/WM_CostSupp.vue'),
                },
                {
                    path: '/index/WM_CostModify',
                    name: 'WM_CostModify',
                    component: () => import('../views/wumeigeren/WM_CostModify.vue'),
                },
                {
                    path: '/index/WM_BUGAIPage',
                    name: 'WM_BUGAIPage',
                    component: () => import('../views/wumeigeren/WM_BUGAIPage.vue'),
                },
                // 补正页
                {
                    path: '/index/WM_SavePage',
                    name: 'WM_SavePage',
                    component: () => import('../views/wumeigeren/WM_SavePage.vue'),
                },
                // 改证页
                {
                    path: '/index/WM_ModifyPage',
                    name: 'WM_ModifyPage',
                    component: () => import('../views/wumeigeren/WM_ModifyPage.vue'),
                },
                //证书查询
                {
                    path: '/index/WM_CertPage',
                    name: 'WM_CertPage',
                    component: () => import('../views/wumeigeren/WM_CertPage.vue'),
                },
                //继续教育
                // {
                //     path: '/index/WM_EduPage',
                //     name: 'WM_EduPage',
                //     component: () => import('../views/wumeigeren/WM_ContinuePage.vue'),
                // },
                //继续教育课程
                // {
                //     path: '/index/WM_CourseContent',
                //     name: 'WM_CourseContent',
                //     component: () => import('../views/wumeigeren/WM_CourseContent.vue'),
                // },
                //继续教育视频
                // {
                //     path: '/index/WM_CourseVideo',
                //     name: 'WM_CourseVideo',
                //     component: () => import('../views/wumeigeren/WM_CourseVideo.vue'),
                // },
                //继续教育课程详情页
                // {
                //     path: '/index/WM_Course',
                //     name: 'WM_Course',
                //     component: () => import('../views/wumeigeren/WM_Course.vue'),
                // },
                //继续教育
                {
                    path: '/index/WM_ContinuePage',
                    name: 'WM_ContinuePage',
                    component: () => import('../views/wumeigeren/WM_ContinuePage.vue'),
                },
                //继续教育-线下培训
                {
                    path: '/index/WM_ContinueOfflinePage',
                    name: 'WM_ContinueOfflinePage',
                    component: () => import('../views/wumeigeren/WM_ContinueOfflinePage.vue'),
                },
                //继续教育-线上培训
                {
                    path: '/index/WM_ContinueOnlinePage',
                    name: 'WM_ContinueOnlinePage',
                    component: () => import('../views/wumeigeren/WM_ContinueOnlinePage.vue'),
                },
                //舞美个人换证
                {
                    path: '/index/WM_RenewalPage',
                    name: 'WM_RenewalPage',
                    component: () => import('../views/wumeigeren/WM_RenewalPage.vue'),
                },
                //线上考试-换证
                {
                    path: '/index/WM_OnlineExamRenewal',
                    name: 'WM_OnlineExamRenewal',
                    component: () => import('../views/wumeigeren/WM_OnlineExamRenewal.vue'),
                },
                //确认邮寄信息-换证
                {
                    path: '/index/WM_MailPageRenewal',
                    name: 'WM_MailPageRenewal',
                    component: () => import('../views/wumeigeren/WM_MailPageRenewal.vue'),
                },

                // {
                //     path: '/index/WM_ChangePage',
                //     name: 'WM_ChangePage',
                //     component: () => import('../views/wumeigeren/WM_ChangePage.vue'),
                // },
                // {
                //     path: '/index/WM_YearRecord',
                //     name: 'WM_YearRecord',
                //     component: () => import('../views/wumeigeren/WM_YearRecord.vue'),
                // },
                //修改信息
                // {
                //     path: '/index/WM_ModifyInfo',
                //     name: 'WM_ModifyInfo',
                //     component: () => import('../views/wumeigeren/WM_ModifyInfo.vue'),
                // },
                 //修改信息--换证
                //  {
                //     path: '/index/WM_ModifyInfoChange',
                //     name: 'WM_ModifyInfoChange',
                //     component: () => import('../views/wumeigeren/WM_ModifyInfoChange.vue'),
                // },

                //线下班次详情--换证
                // {
                //     path: '/index/OfflineExamDetChange',
                //     name: 'OfflineExamDetChange',
                //     component: () => import('../views/wumeigeren/components/OfflineExamDetChange.vue'),
                // },
                // 网络表演
                {
                    path: '/index/NP_HomePage',
                    name: 'NP_HomePage',
                    component: () => import('../views/networkPerform/NP_HomePage.vue'),
                },
                //课程中心
                {
                    path: '/index/NP_CoursePage',
                    name: 'NP_CoursePage',
                    component: () => import('../views/networkPerform/NP_CoursePage.vue'),
                },
                //网络表演课程
                {
                    path: '/index/NetCourseContent',
                    name: 'NetCourseContent',
                    component: () => import('../views/networkPerform/CourseContent.vue'),
                },
                // //网络表演视频播放
                {
                    path: '/index/NetCourseVideo',
                    name: 'NetCourseVideo',
                    component: () => import('../views/networkPerform/CourseVideo.vue'),
                },

                //办事机构
                {
                    path: '/index/NPOrganList',
                    name: 'NPOrganList',
                    component: () => import('../views/networkPerformNews/OrganList.vue'),
                },
                {
                    path: '/index/NPOrganDetail',
                    name: 'NPOrganDetail',
                    component: () => import('../views/networkPerformNews/OrganDetail.vue'),
                },
                // 工作动态
                {
                    path: '/index/NPDynamicList',
                    name: 'NPDynamicList',
                    component: () => import('../views/networkPerformNews/NPDynamicList.vue'),
                },
                //党建之窗
                {
                    path: '/index/PartyBuildingList',
                    name: 'PartyBuildingList',
                    component: () => import('../views/partyBuildingView/PartyBuildingList.vue'),
                },
                //详情
                {
                    path: '/index/np/NewsDetail',
                    name: 'NewsDetail',
                    component: () => import('../views/networkPerformNews/NewsDetail.vue'),
                },
                //个人页面
                {
                    path: '/index/NP_UserPage',
                    name: 'NP_UserPage',
                    component: () => import('../views/networkPerform/NP_UserPage.vue'),
                },
                {
                    path: '/index/NP_UserEnrollPage',
                    name: 'NP_UserEnrollPage',
                    component: () => import('../views/networkPerform/NP_UserEnrollPage.vue'),
                },
                {
                    path: '/index/NP_EnrollPage',
                    name: 'NP_EnrollPage',
                    component: () => import('../views/networkPerform/NP_EnrollPage.vue'),
                },
                {
                    path: '/index/NP_TrainPage',
                    name: 'NP_TrainPage',
                    component: () => import('../views/networkPerform/NP_TrainPage.vue'),
                },
                {
                    path: '/index/NP_ExamPage',
                    name: 'NP_ExamPage',
                    component: () => import('../views/networkPerform/NP_ExamPage.vue'),
                },
                {
                    path: '/index/NP_CertPage',
                    name: 'NP_CertPage',
                    component: () => import('../views/networkPerform/NP_CertPage.vue'),
                },

                //舞美企业
                {
                    path: '/index/WMQY_UserPage',
                    name: 'WMQY_UserPage',
                    component: () => import('../views/wumeiqiye/WMQY_UserPage.vue'),
                },
                //提交报名信息
                {
                    path: '/index/WMQY_EnrollPage',
                    name: 'WMQY_EnrollPage',
                    component: () => import('../views/wumeiqiye/WMQY_EnrollPage.vue'),
                },
                //邮寄线下材料
                {
                    path: '/index/WMQY_MeterialPage',
                    name: 'WMQY_MeterialPage',
                    component: () => import('../views/wumeiqiye/WMQY_MeterialPage.vue'),
                },
                //提交评审费用
                // {
                //     path: '/index/WMQY_CostReview',
                //     name: 'WMQY_CostReview',
                //     component: () => import('../views/wumeiqiye/WMQY_CostReview.vue'),
                // },
                //提交证书费用
                // {
                //     path: '/index/WMQY_CostService',
                //     name: 'WMQY_CostService',
                //     component: () => import('../views/wumeiqiye/WMQY_CostService.vue'),
                // },
                //查看复审信息
                {
                    path: '/index/WMQY_ReviewPage',
                    name: 'WMQY_ReviewPage',
                    component: () => import('../views/wumeiqiye/WMQY_ReviewPage.vue'),
                },
                //提交终审信息
                {
                    path: '/index/WMQY_FinalPage',
                    name: 'WMQY_FinalPage',
                    component: () => import('../views/wumeiqiye/WMQY_FinalPage.vue'),
                },
                 //确认邮寄信息
                {
                    path: '/index/WMQY_MailPage',
                    name: 'WMQY_MailPage',
                    component: () => import('../views/wumeiqiye/WMQY_MailPage.vue'),
                },

                {
                    path: '/index/WMQY_ModifyPage',
                    name: 'WMQY_ModifyPage',
                    component: () => import('../views/wumeiqiye/WMQY_ModifyPage.vue'),
                },
                {
                    path: '/index/WMQY_SavePage',
                    name: 'WMQY_SavePage',
                    component: () => import('../views/wumeiqiye/WMQY_SavePage.vue'),
                },
                // {
                //     path: '/index/WMQY_CostSupp',
                //     name: 'WMQY_CostSupp',
                //     component: () => import('../views/wumeiqiye/WMQY_CostSupp.vue'),
                // },
                // {
                //     path: '/index/WMQY_CostModify',
                //     name: 'WMQY_CostModify',
                //     component: () => import('../views/wumeiqiye/WMQY_CostModify.vue'),
                // },
                {
                    path: '/index/WMQY_BUGAIPage',
                    name: 'WMQY_BUGAIPage',
                    component: () => import('../views/wumeiqiye/WMQY_BUGAIPage.vue'),
                },
                // {
                //     path: '/index/WMQY_ChangePage',
                //     name: 'WMQY_ChangePage',
                //     component: () => import('../views/wumeiqiye/WMQY_ChangePage.vue'),
                // },
                {
                    path: '/index/WMQY_RenewalPage',
                    name: 'WMQY_RenewalPage',
                    component: () => import('../views/wumeiqiye/WMQY_RenewalPage.vue'),
                },
                {
                    path: '/index/WMQY_ReviewAgainPage',
                    name: 'WMQY_ReviewAgainPage',
                    component: () => import('../views/wumeiqiye/WMQY_ReviewAgainPage.vue'),
                },
                //邮寄线下材料
                {
                    path: '/index/WMQY_MeterialRenewalPage',
                    name: 'WMQY_MeterialRenewalPage',
                    component: () => import('../views/wumeiqiye/WMQY_MeterialRenewalPage.vue'),
                },
                //提交终审信息
                {
                    path: '/index/WMQY_FinalRenewalPage',
                    name: 'WMQY_FinalRenewalPage',
                    component: () => import('../views/wumeiqiye/WMQY_FinalRenewalPage.vue'),
                },
                //确认邮寄信息
                {
                    path: '/index/WMQY_MailRenewalPage',
                    name: 'WMQY_MailRenewalPage',
                    component: () => import('../views/wumeiqiye/WMQY_MailRenewalPage.vue'),
                },



                //首页
                {
                    path: '/index/HomePage',
                    name: 'HomePage',
                    component: () => import('../views/HomePage.vue'),
                },
                //新闻详情
                {
                    path: '/index/NewsDetail',
                    name: 'NewsDetail',
                    component: () => import('../views/NewsDetail.vue'),
                },
                //活动详情
                {
                    path: '/index/ActivetyDetail',
                    name: 'ActivetyDetail',
                    component: () => import('../views/ActivetyDetail.vue'),
                },
                // 协会概况
                {
                    path: '/index/AboutUsList',
                    name: 'AboutUsList',
                    component: () => import('../views/aboutUsView/AboutUsList.vue'),
                },
                // 行业动态
                {
                    path: '/index/DynamicList',
                    name: 'DynamicList',
                    component: () => import('../views/dynamicView/DynamicList.vue'),
                },
                // 热点专题
                {
                    path: '/index/TopicList',
                    name: 'TopicList',
                    component: () => import('../views/topicView/TopicList.vue'),
                },
                // 标准规范
                {
                    path: '/index/StandardList',
                    name: 'StandardList',
                    component: () => import('../views/standardView/StandardList.vue'),
                },
                // 政策法规
                {
                    path: '/index/PolicyList',
                    name: 'PolicyList',
                    component: () => import('../views/policyView/PolicyList.vue'),
                },

                // 行业研究
                {
                    path: '/index/ResearchList',
                    name: 'ResearchList',
                    component: () => import('../views/researchView/ResearchList.vue'),
                },

                //会员单位
                {
                    path: '/index/VipList',
                    name: 'VipList',
                    component: () => import('../views/vipView/VipList.vue'),
                    children: [
                        // 入会须知
                        {
                            path: '/index/MemberGuide',
                            name: 'MemberGuide',
                            component: () => import('../views/vipView/MemberGuide.vue'),
                        },
                        //入会申请
                        {
                            path: '/index/MemberApply',
                            name: 'MemberApply',
                            component: () => import('../views/vipView/MemberApply.vue'),
                        },
                        //常务理事单位
                        {
                            path: '/index/ExecutiveDirectorMember',
                            name: 'ExecutiveDirectorMember',
                            component: () => import('../views/vipView/ExecutiveDirectorMember.vue'),
                        },
                        //理事单位
                        {
                            path: '/index/DirectorMember',
                            name: 'DirectorMember',
                            component: () => import('../views/vipView/DirectorMember.vue'),
                        },
                        //会员单位
                        {
                            path: '/index/MemberUnits',
                            name: 'MemberUnits',
                            component: () => import('../views/vipView/MemberUnits.vue'),
                        },
                        //会员风采
                        {
                            path: '/index/MemberStyle',
                            name: 'MemberStyle',
                            component: () => import('../views/vipView/MemberStyle.vue'),
                        },
                    ]
                },
                {
                    path: '/index/VipApply',
                    name: 'VipApply',
                    component: () => import('../views/vipView/VipApply.vue'),
                },
                {
                    path: '/index/VipDynamicList',
                    name: 'VipDynamicList',
                    component: () => import('../views/vipView/DynamicList.vue'),
                },
                {
                    path: '/index/VipDynamic/NewsDetail',
                    name: 'VipDynamicNewsDetail',
                    component: () => import('../views/vipView/NewsDetail.vue'),
                },
                {
                    path: '/index/VipDynamic/NocDetail',
                    name: 'VipDynamicNocDetail',
                    component: () => import('../views/vipView/NocDetail.vue'),
                },

                {
                    path: '/index/aboutUsView/OrganDet',
                    name: 'OrganDet',
                    component: () => import('../views/aboutUsView/OrganDet.vue'),
                },

                //会议活动

                {
                    path: '/index/MeetingHome',
                    name: 'MeetingHome',
                    component: () => import('../views/meetingsView/MeetingHome.vue'),
                },
                {
                    path: '/index/MeetingList',
                    name: 'MeetingList',
                    component: () => import('../views/meetingsView/MeetingList.vue'),
                },

                //培训动态
                {
                    path: '/index/TrainingTrendsList',
                    name: 'TrainingTrendsList',
                    component: () => import('../views/trainingTrendsView/TrainingTrendsList.vue'),
                },


                {
                    path: '/index/VipPolicyList',
                    name: 'VipPolicyList',
                    component: () => import('../views/vipView/PolicyList.vue'),
                },

                {
                    path: '/index/VipPolicyDet',
                    name: 'VipPolicyDet',
                    component: () => import('../views/vipView/PolicyDetail.vue'),
                },

                {
                    path: '/index/VipNoticeList',
                    name: 'VipNoticeList',
                    component: () => import('../views/vipView/NoticeList.vue'),
                },
                {
                    path: '/index/VipNotice/NewsDetail',
                    name: 'VipNoticeDetail',
                    component: () => import('../views/vipView/NoticeDetail.vue'),
                },

                {
                    path: '/index/VipNoticeList',
                    name: 'VipNoticeList',
                    component: () => import('../views/vipView/NoticeList.vue'),
                },

                {
                    path: '/index/IndustryReport',
                    name: 'IndustryReport',
                    component: () => import('../views/vipView/IndustryReport.vue'),
                },

                {
                    path: '/index/EtcList',
                    name: 'EtcList',
                    component: () => import('../views/vipView/EtcList.vue'),
                },

                {
                    path: '/index/AnnualReport',
                    name: 'AnnualReport',
                    component: () => import('../views/vipView/AnnualReport.vue'),
                },

                //会员服务
                {
                    path: '/index/VipServies',
                    name: 'VipServies',
                    component: () => import('../views/vipView/VipServies.vue'),
                },

                //学习中心
                {
                    path: '/index/CourseHome',
                    name: 'CourseHome',
                    component: () => import('../views/courseView/CourseHome.vue')
                },
                {
                    path: '/index/CourseMore',
                    name: 'CourseMore',
                    component: () => import('../views/courseView/CourseMore.vue')
                },
                {
                    path: '/index/CourseList',
                    name: 'CourseList',
                    component: () => import('../views/courseView/CourseList.vue')
                },
                {
                    path: '/index/CourseContent',
                    name: 'CourseContent',
                    component: () => import('../views/courseView/CourseContent.vue')
                },
                {
                    path: '/index/CourseCountinueContent',
                    name: 'CourseCountinueContent',
                    component: () => import('../views/courseView/CourseCountinueContent.vue')
                },
                {
                    path: '/index/CourseVideo',
                    name: 'CourseVideo',
                    component: () => import('../views/courseView/CourseVideo.vue')
                },

                //个人中心
                {
                    path: '/index/user',
                    name: 'User',
                    component: () => import('../views/userView/User.vue'),
                    children: [{
                            path: '/index/userInfo',
                            name: 'UserInfo',
                            component: () => import('../views/userView/UserInfo.vue'),
                        },
                        {
                            path: '/index/userInfoExpand',
                            name: 'UserInfoExpand',
                            component: () => import('../views/userView/UserInfoExpand.vue'),
                        },
                        {
                            path: '/index/ChangeManager',
                            name: 'ChangeManager',
                            component: () => import('../views/userView/ChangeManager.vue'),
                        },
                        {
                            path: '/index/userPassword',
                            name: 'UserPassword',
                            component: () => import('../views/userView/UserPassword.vue'),
                        },
                        {
                            path: '/index/userBusiness',
                            name: 'UserBusiness',
                            component: () => import('../views/userView/UserBusiness.vue'),
                        },
                        {
                            path: '/index/mailInfo',
                            name: 'MailInfo',
                            component: () => import('../views/userView/MailInfo.vue'),
                        },
                        {
                            path: '/index/InvoiceInfo',
                            name: 'InvoiceInfo',
                            component: () => import('../views/userView/InvoiceInfo.vue'),
                        },

                        {
                            path: '/index/UserOrder',
                            name: 'UserOrder',
                            component: () => import('../views/userView/UserOrder.vue'),
                        },
                        {
                            path: '/index/UserOrderWLBY',
                            name: 'UserOrderWLBY',
                            component: () => import('../views/userView/UserOrderWLBY.vue'),
                        }
                    ]
                },

                //企业中心
                {
                    path: '/index/ent',
                    name: 'Ent',
                    component: () => import('../views/entView/Ent.vue'),
                    children: [{
                            path: '/index/UserEnt',
                            name: 'UserEnt',
                            component: () => import('../views/entView/UserEnt.vue'),
                        },
                        {
                            path: '/index/ModifyManager',
                            name: 'ModifyManager',
                            component: () => import('../views/entView/ModifyManager.vue'),
                        },
                        {
                            path: '/index/EntMember',
                            name: 'EntMember',
                            component: () => import('../views/entView/EntMember.vue'),
                        },
                        {
                            path: '/index/ModifyPwd',
                            name: 'ModifyPwd',
                            component: () => import('../views/entView/ModifyPwd.vue'),
                        },
                        {
                            path: '/index/EntBusiness',
                            name: 'EntBusiness',
                            component: () => import('../views/entView/EntBusiness.vue'),
                        },
                        {
                            path: '/index/EntVipInfo',
                            name: 'EntVipInfo',
                            component: () => import('../views/entView/EntVipInfo.vue'),
                        },

                        {
                            path: '/index/EntMailInfo',
                            name: 'EntMailInfo',
                            component: () => import('../views/entView/EntMailInfo.vue'),
                        },
                        {
                            path: '/index/EntInvoiceInfo',
                            name: 'EntInvoiceInfo',
                            component: () => import('../views/entView/EntInvoiceInfo.vue'),
                        },

                        {
                            path: '/index/EntUserOrder',
                            name: 'EntUserOrder',
                            component: () => import('../views/entView/EntUserOrder.vue'),
                        }
                    ]
                },

                //修改企业认证信息
                {
                    path: '/index/editUserEnt',
                    name: 'editUserEnt',
                    component: () => import('../views/entView/EditUserEnt.vue'),
                },

            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js